import { useState } from 'react';

const services = [
  {
    icon: 'ri-eye-line',
    title: 'Bryn og Vipper',
    description: 'Profesjonell forming, farging og laminering av bryn og vipper. Vi skaper den perfekte rammen for ditt blikk.',
    tags: ['Laminering', 'Farging', 'Forming', 'Extensions'],
  },
  {
    icon: 'ri-user-smile-line',
    title: 'Ansiktsbehandlinger',
    description: 'Skreddersydde hudpleiebehandlinger tilpasset din hudtype. Fra dyprengjøring til anti-age og fuktighetsbehandlinger.',
    tags: ['Dyprengjøring', 'Anti-age', 'Fuktighet', 'Peeling'],
  },
  {
    icon: 'ri-sparkling-line',
    title: 'Plasma Pen / PRP',
    description: 'Avanserte ikke-kirurgiske behandlinger for hudforyngelse. Plasma Pen og Plasma PRP for synlige resultater.',
    tags: ['Plasma Pen', 'PRP', 'Hudforyngelse', 'Anti-age'],
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Fotpleie',
    description: 'Komplett fotpleie for myke og velstelte føtter. Vi tilbyr profesjonell behandling tilpasset dine behov.',
    tags: ['Gel', 'Shellac', 'Klassisk', 'Fotpleie'],
  },
  {
    icon: 'ri-leaf-line',
    title: 'Voksing',
    description: 'Effektiv og skånsom hårfjerning med voks. Vi tilbyr voksing for alle kroppsdeler med fokus på komfort.',
    tags: ['Ansikt', 'Kropp', 'Brasiliansk', 'Skånsom'],
  },
  {
    icon: 'ri-body-scan-line',
    title: 'Refit',
    description: 'Moderne kroppsformende behandlinger med Refit-teknologi. Stram opp huden og reduser cellulitter effektivt.',
    tags: ['Kroppsforming', 'Cellulitter', 'Hudstramming'],
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'LPG Massasje & Osteopati',
    description: 'Terapeutisk massasje og osteopatisk behandling for kropp og sinn. LPG-teknologi for dypvirkende resultater.',
    tags: ['LPG', 'Massasje', 'Osteopati', 'Avslapning'],
  },
  {
    icon: 'ri-plant-line',
    title: 'Kosthold',
    description: 'Personlig kostholdsveiledning og ernæringsrådgivning tilpasset dine mål. Vi hjelper deg å bygge sunne vaner for et bedre liv.',
    tags: ['Veiledning', 'Ernæring', 'Vektnedgang', 'Helse'],
  },
];

export default function Services() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section id="services" className="py-20 md:py-28 bg-[#0e0a07]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#c9a84c]/30 bg-[#c9a84c]/8 mb-5 md:mb-6">
            <span className="text-[#c9a84c] text-xs tracking-[0.2em] uppercase font-medium">Våre Tjenester</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Skreddersydde behandlinger
            <br />
            <span className="text-[#c9a84c]">for deg</span>
          </h2>
          <p className="text-white/50 text-base md:text-lg max-w-xl mx-auto leading-relaxed px-2">
            Vi tilbyr et bredt spekter av profesjonelle skjønnhets- og velværebehandlinger, alltid tilpasset dine individuelle behov.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {services.map((service, i) => (
            <div
              key={service.title}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              className={`relative rounded-2xl border overflow-hidden transition-all duration-300 cursor-pointer group ${
                hovered === i
                  ? 'border-[#c9a84c]/50'
                  : 'border-white/8'
              }`}
            >
              {/* Decorative icon area */}
              <div className={`relative w-full h-40 flex items-center justify-center transition-all duration-300 ${
                hovered === i
                  ? 'bg-gradient-to-br from-[#c9a84c]/20 via-[#c9a84c]/8 to-transparent'
                  : 'bg-gradient-to-br from-white/5 via-white/2 to-transparent'
              }`}>
                {/* Decorative ring */}
                <div className={`absolute w-28 h-28 rounded-full border transition-all duration-300 ${
                  hovered === i ? 'border-[#c9a84c]/25 scale-110' : 'border-white/6 scale-100'
                }`} />
                <div className={`absolute w-20 h-20 rounded-full border transition-all duration-300 ${
                  hovered === i ? 'border-[#c9a84c]/15' : 'border-white/4'
                }`} />
                {/* Main icon */}
                <div className={`relative w-16 h-16 flex items-center justify-center rounded-2xl transition-all duration-300 ${
                  hovered === i
                    ? 'bg-[#c9a84c] shadow-lg shadow-[#c9a84c]/20'
                    : 'bg-white/6'
                }`}>
                  <i className={`${service.icon} text-2xl transition-colors duration-300 ${
                    hovered === i ? 'text-[#0e0a07]' : 'text-[#c9a84c]'
                  }`} />
                </div>
                {/* Corner number */}
                <span className="absolute top-3 right-4 text-[10px] font-mono tracking-widest text-white/15">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>

              {/* Content */}
              <div className={`p-5 transition-colors duration-300 ${
                hovered === i ? 'bg-[#c9a84c]/8' : 'bg-white/3'
              }`}>
                <h3 className="text-white font-semibold text-sm md:text-base mb-2 leading-snug">{service.title}</h3>
                <p className="text-white/50 text-xs md:text-sm leading-relaxed mb-3 md:mb-4">{service.description}</p>

                {/* Tags */}
                <div className="flex flex-wrap gap-1.5">
                  {service.tags.map((tag) => (
                    <span
                      key={tag}
                      className={`text-[10px] px-2 py-0.5 rounded-full border transition-colors duration-300 ${
                        hovered === i
                          ? 'border-[#c9a84c]/40 text-[#c9a84c]/80 bg-[#c9a84c]/10'
                          : 'border-white/10 text-white/40'
                      }`}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              {/* Arrow */}
              <div className={`absolute top-3 left-3 w-7 h-7 flex items-center justify-center rounded-full transition-all duration-300 ${
                hovered === i ? 'bg-[#c9a84c]/20 opacity-100' : 'opacity-0'
              }`}>
                <i className="ri-arrow-right-up-line text-[#c9a84c] text-sm" />
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10 md:mt-12">
          <button
            onClick={() => window.open('https://system.easypractice.net/book/equi#choose-where', '_blank')}
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#c9a84c] text-[#0e0a07] font-semibold rounded-full hover:bg-[#e0c06a] active:scale-95 transition-all duration-300 text-sm tracking-wide cursor-pointer whitespace-nowrap"
          >
            <span>Bestill din behandling</span>
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
